import axios from './axiosInstance';

export const fetchGroups = () => axios.get('/groups');
export const createGroup = (data) => axios.post('/groups', data);
export const deleteGroup = (id) => axios.delete(`/groups/${id}`);

